if (!customElements.get('ohrheld-purchase-offers')) {
  customElements.define(
    'ohrheld-purchase-offers',
    class OhrheldPurchaseOffers extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('.quantity__input');
        this.offerRadios = Array.from(this.querySelectorAll('.oh-purchase__offer-radio'));
        this.submitLabel = this.querySelector('[data-oh-purchase-submit-label]');

        if (!this.quantityInput || this.offerRadios.length === 0) return;

        this.offerRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;

            this.quantityInput.value = radio.value;
            this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            this.updateState();
          });
        });

        this.quantityInput.addEventListener('input', () => this.updateState());
        this.quantityInput.addEventListener('change', () => this.updateState());
        this.updateState();
      }

      updateState() {
        const quantity = Number.parseInt(this.quantityInput.value, 10);

        this.offerRadios.forEach((radio) => {
          radio.checked = Number.parseInt(radio.value, 10) === quantity;
        });

        if (!this.submitLabel || this.submitLabel.closest('button')?.disabled) return;

        const defaultLabel = this.submitLabel.dataset.defaultLabel;
        const bundleLabel = this.submitLabel.dataset.bundleLabel;
        this.submitLabel.textContent = quantity === 2 ? bundleLabel : defaultLabel;
      }
    }
  );
}
